import { Autocomplete, Box, DialogActions, DialogContent, DialogTitle, Icon, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from "components/roundedbutton/CustomButton";
import HeaderOuBannerDependendoDaInterpretacaoH1 from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { ColumnData, resolveWrapper } from "utils/util";
import VendaService from "../venda.service";
import { TMotivo } from "../vendas.model";

export type TCancelamentoDialog<T> = {
    header: string;
    open: boolean;
    onClose: () => void,
    onConfirm: (item: T, uuidMotivo: string) => void;
    item: T | null | undefined;
    columns: ColumnData<T>[];
};

export type LocalState = {
    motivo: TMotivo | null,
    motivos: Array<TMotivo>,
    motivoFiltro: string;
};

const initialState: LocalState = {
    motivo: null,
    motivos: [],
    motivoFiltro: ''
};

const CancelaCoisasDialog = <T extends {}>(props: TCancelamentoDialog<T>) => {
    const [stateLocal, setStateLocal] = useState(initialState);
    const vendasService = VendaService();

    const getMotivos = useCallback(() => {
        vendasService.getMotivos()
            .then(({ data }: { data: Array<TMotivo>; }) => {
                setStateLocal(prevState => ({ ...prevState, motivos: data }));
            })
            .catch(() => { });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.open) {
            getMotivos();
        } else {
            setStateLocal(initialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open]);

    const onSelectMotivo = useCallback((e: SyntheticEvent<Element, Event>, value: TMotivo | null) => {
        if (value) { return setStateLocal(prevState => ({ ...prevState, motivo: value })); }
        return setStateLocal(prevState => ({ ...prevState, motivo: initialState.motivo }));
    }, []);

    const onInputChangeMotivosAc = (e: SyntheticEvent<Element, Event>, value: string) => {
        setStateLocal(prevState => ({ ...prevState, motivoFiltro: value }));
    };

    const motivosOptions = () => {
        const motivos = stateLocal.motivos;
        const filtro = stateLocal.motivoFiltro.toLowerCase();

        if (!filtro) {
            return motivos;
        }

        return motivos.filter(e =>
            e.descritivo.toLowerCase().includes(filtro)
        );
    };
    const onBlurMotivos = () => {
        if (!stateLocal.motivo?.descritivo.length) {
            getMotivos();
        }
    };

    if (!props.item) {
        return <></>;
    }

    return (
        <CustomDialog
            open={props.open}
            fullWidth={true}
            maxWidth={'md'}
            onClose={props.onClose}
        >
            <DialogTitle>
                <HeaderOuBannerDependendoDaInterpretacaoH1
                    id='cancela-coisa-dialog'
                    small
                    iconClassName="fa-solid fa-trash"
                    label={props.header}
                />
            </DialogTitle>

            <DialogContent sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <TableContainer sx={{ width: '100%' }}>
                    <Table id="content-table"
                        stickyHeader
                        size="small"
                        sx={{ tableLayout: "fixed" }}
                    >
                        <TableHead sx={{ width: '100%', bgcolor: 'green' }}>
                            <TableRow>
                                {props.columns.map(col => {
                                    return <TableCell
                                        sx={{ whiteSpace: 'nowrap', textAlign: 'center', fontWeight: 'bold' }}
                                        key={`cancelamento_${col.id}`}
                                    >
                                        {col.header}
                                    </TableCell>;
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            <TableRow>

                                {props.columns.map(col => {
                                    return <TableCell
                                        sx={{
                                            whiteSpace: 'nowrap',
                                            textAlign: 'center',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            width: '100%',
                                        }}
                                        key={`cancelamento_${col.id}`}
                                    >
                                        {col.convert?.(props.item!, { column: col }) ?? resolveWrapper(props.item, col.key)}
                                    </TableCell>;
                                })}
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Autocomplete
                    style={{ width: '100%', marginTop: '20px' }}
                    onBlur={onBlurMotivos}
                    id="auto-complete-motivos-cancelamento"
                    value={stateLocal.motivo}
                    options={motivosOptions()}
                    getOptionLabel={(option) => option.descritivo}
                    isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                    onInputChange={onInputChangeMotivosAc}
                    onChange={onSelectMotivo}
                    filterOptions={(x) => x}
                    noOptionsText={'Nenhum resultado encontrado'}
                    renderInput={
                        (params) => <TextField  {...params}
                            label="Motivo *"
                            variant="standard"
                        />}
                />
            </DialogContent>

            <DialogActions
                sx={{
                    flexDirection: 'column',
                }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', marginTop: '20px' }}>
                    <CustomButton onClick={props.onClose} variant="contained" color="error" startIcon={<Icon className='fa-solid fa-xmark' />} >
                        Não
                    </CustomButton>
                    <CustomButton
                        onClick={() => {
                            props.onConfirm(props.item!, stateLocal.motivo!.uuid);
                            props.onClose();
                        }}
                        type="submit"
                        variant="contained"
                        color="success"
                        startIcon={<Icon className='fa-solid fa-check' />}
                        disabled={!stateLocal.motivo}>
                        Sim
                    </CustomButton>
                </Box>
            </DialogActions>
        </CustomDialog>
    );
};

export default CancelaCoisasDialog;
